/**
 * The "Super Admin → Site changed" signal, kept apart from lib/useSiteContent.js so a
 * writer can raise it without importing the reader's HTTP stack (and so both import it
 * for real under Jest — this module has no dependencies).
 *
 * Every successful HQ Site write calls `invalidateSiteContent()`. The public hook drops
 * its module cache and mounted readers re-fetch at once (`onSiteContentInvalidated`); an
 * answer to a request sent under an older `siteContentVersion()` is discarded.
 */

let version = 0;
const listeners = new Set();

/** The current version; bumped by every invalidation. */
export const siteContentVersion = () => version;

/** Mark the public site payload stale. */
export function invalidateSiteContent() {
  version += 1;
  listeners.forEach((listener) => listener(version));
}

/** @returns {() => void} unsubscribe */
export function onSiteContentInvalidated(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
